"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeedbackBenefitDialog = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _contexts = require("../../contexts");
var _Loading = require("../Loading");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Content = /*#__PURE__*/(0, _react.lazy)(async () => ({
  default: (await Promise.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "FeedbackBenefitDialog_Content" */'./Content')))).Content
}));

/**
 * Shows feedback benefit dialog
 */
const FeedbackBenefitDialog = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    open,
    onClose
  } = (0, _contexts.useFeedbackBenefitDialog)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Dialog, {
    "data-testid": getTestId(_constants.FEEDBACK_BENEFIT_DIALOG),
    open: open,
    onClose: onClose,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
      fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.Loading, {}),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Content, {})
    })
  });
};
exports.FeedbackBenefitDialog = FeedbackBenefitDialog;
